import { isCurrentCultureRightToLeft } from 'owa-localize';
import classnames from 'owa-classnames';
import { sidebarVisible, sidebarHidden, sidebarHiddenRtl } from '../LeftPane.scss';

/**
 * Returns correct styling behavior for rendering left pane
 */

export const useLeftPaneContentStyle = (showLeftPane: boolean): string => {
    if (showLeftPane) {
        return sidebarVisible;
    }
    return classnames(sidebarHidden, isCurrentCultureRightToLeft() && sidebarHiddenRtl);
};
